/**
 * Firebase Analytics – shared Valkyrie Firebase project.
 */

import {getAnalytics, isSupported} from 'firebase/analytics';
import {getApps, initializeApp} from 'firebase/app';
import env from 'env';

const firebaseConfig = {
  apiKey: env.VALKYRIE_FIREBASE_API_KEY,
  authDomain: env.VALKYRIE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VALKYRIE_FIREBASE_PROJECT_ID,
  storageBucket: env.VALKYRIE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VALKYRIE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VALKYRIE_FIREBASE_APP_ID,
  measurementId: env.VALKYRIE_FIREBASE_MEASUREMENT_ID,
};

let analyticsPromise = Promise.resolve(null);

if (!getApps().length && typeof window !== 'undefined') {
  const app = initializeApp(firebaseConfig);

  analyticsPromise = isSupported().then((supported) => (supported ? getAnalytics(app) : null));
}

export {analyticsPromise};
